import { objectReduce } from 'fela-utils';

export default {
  create: function create(styleSheet) {
    return objectReduce(styleSheet, function (ruleSheet, rule, ruleName) {
      if (typeof rule === 'function') {
        ruleSheet[ruleName] = rule;
      } else {
        ruleSheet[ruleName] = function () {
          return rule;
        };
      }

      return ruleSheet;
    }, {});
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-tools/es/StyleSheet.js
// module id = 739
// module chunks = 0